import { z } from 'zod';
import type { WorkIntegration_Keys } from '@/lib/api/types/work-integrations';

export const workIntegrationSearchSchema = z.object({
  integration: z.custom<WorkIntegration_Keys>().optional(),
  oauthCredentialsId: z.number().optional(),
});
